import { CloseCircleOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "antd";
import styled from "styled-components";

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexCenterColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
`;

export const FlexEndDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FlexStartDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const FlexCenterLine = styled.span`
  display: flex;
  align-items: center;
  align-content: center;
`;

export const FlexCenterRow = styled.span`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

export const FlexCenterColumnAndRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
`;

export const FlexStartColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
`;

export const FlexSpaceBetween = styled.span`
  display: flex;
  justify-content: space-between;
`;

export const FlexSpaceBetweenDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const FlexSpaceBetweenColumn = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
`;

export const FixedBottomContainer = styled.div<{
  height: number;
  color: string;
}>`
  position: fixed;
  padding: 10px;
  left: 0;
  bottom: 0;
  z-index: 9999;
  background: ${(props) => props.color};
  width: 100%;
  height: ${(props) => props.height}px;
`;

export const VerticalScrollContainer = styled.div<{
  maxHeight: number;
}>`
  max-height: ${(props) => props.maxHeight}px;
  overflow-y: auto;
`;

export const FlexCenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

export const FlexDiv = styled.div`
  display: flex;
`;

export const StyledReportTypeDiv = styled.div`
  width: 400px;
  margin: 5px;
  background: #fff;
  padding: 10px;
  margin-left: 0;
`;

export const StyledHistoryDiv = styled.div`
  background: #fff;
  padding: 10px;
  flex-grow: 1;
  flex-column: 1;
  overflow: scroll;
  margin: 5px;
  border-radius: 4px 4px 0px 0px;
`;

export const StyledBtnDiv = styled.div`
  height: 100%;
  margin-bottom: 12px;
`;

export const StyledText = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #404041;
  padding: 5px;
  border-bottom: 1px solid #f2f2f3;
`;

export const StyledReportHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 5px 2px 0;
  background: #fff;
  padding: 10px;
  font-weight: 700;
  font-size: 16px;
  color: #fe6a00;
`;

export const ColumnTitle = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 120%;
`;

export const ColumnContent = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
`;

export const CategorySubMenu = styled.div`
  width: 350px;
  position: absolute;
  z-index: 1;
  background: #ffff;
  left: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 475px;
  transform: translateY(-3.5em);
  box-shadow: 10px 0 10px -5px rgba(114, 114, 114, 0.25) !important;
  -webkit-box-shadow: 10px 0 10px -5px rgba(114, 114, 114, 0.25) !important;
  -moz-box-shadow: 10px 0 10px -5px rgba(114, 114, 114, 0.25) !important;
`;

export const CategoryItem = styled.div`
  height: 40px;
  padding: 18px 24px;
  &:hover {
    background: #fff2e9;
    border-right: 3px solid #fe6a00;
    color: #fe6a00;
    cursor: pointer;
  }
`;

export const EmptyListMsg = styled.div`
  height: 40px;
  padding: 18px 24px;
  color: #a7a8a7;
`;

export const UsernameSpan = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  margin: 10px;
`;

export const StyledArrow = styled(FontAwesomeIcon)`
  padding: 0 10px;
  &:hover {
    cursor: pointer;
    color: #fe6a00;
  }
`;

export const Usernamediv = styled.div`
  text-align: center;
  padding: 0 12px;
  min-width: 120px;
  margin: 0;
  height: 40px;
  position: relative;
  z-index: 5;
  bottom: 25px;
  left: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
`;

export const UserMenu = styled.div`
  background: #ffff;
  padding: 0 10px;
  padding-bottom: 15px;
  border-radius: 5px;
  position: absolute;
  z-index: 10;
  top: 45px;
  box-shadow: 0 0 10px rgba(114, 114, 114, 0.25) !important;
  -webkit-box-shadow: 0 0 10px rgba(114, 114, 114, 0.25) !important;
  -moz-box-shadow: 0 0 10px rgba(114, 114, 114, 0.25) !important;
`;

export const UsermenuItem = styled.div`
  padding: 0px 10px;
  width: 120px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
    color: #fe6a00;
  }
`;

export const LanguageIcon = styled(FontAwesomeIcon)`
  padding-top: 25px;
  color: #1e1e1e;
`;

export const ReportSettingsIcon = styled(FontAwesomeIcon)`
  color: #626263;
  margin-left: 10px;
  &:hover {
    color: #fe6a00;
  }
`;

export const ReportNameSettings = styled.div`
  font-weight: 700;
  padding-bottom: 12px;
`;

export const CardCover = styled.div`
  padding: 20px;
  background-color: #f5f5f5;
  border-bottom: 2px solid #e9e9e9;

  overflow-x: hidden;
`;

export const PageHeader = styled.div`
height: 200px;
background-color: #fe6a00;
padding: 75px;
text-align: center;
font-size: 31px;
font-weight: 800;
line-height: 37.2px;
color: #FFFFFF;
z-index:10px;
`;

export const PageDescription = styled.div`
font-size: 17px;
font-weight: 400;
line-height: 20px;
text-align: center;
padding-top: 15px;
`;

export const SearchInput = styled(Input)`
width: 720px;
height: 46px;
padding: 16px 24px 16px 24px;
border-radius: 4px;
border: 1px ;
position: relative;
top: 23px;
box-shadow: 0px 3.391551971435547px 4.921075344085693px 0px #4A637507 !important;
box-shadow: 0px 11.391517639160156px 16.528867721557617px 0px #4A63750B !important;
box-shadow: 0px 51px 74px 0px #4A637512 !important;
`;

export const VideoContainer = styled.div`
width: 250px;
height: 360px;
padding: 20px;
border-radius: 4px;
margin: 20px;
background-color:#FFFFFF;
display: inline-block;
`;

export const VideoDescription = styled.div`
font-size: 14px;
font-weight: 400;
line-height: 17px;
letter-spacing: 0em;
margin: 5px;
color: #404041;
height: 70px;
`;

export const WatchBtn = styled(Button)`
position: relative;
width: 100%;
height: 30px;
background-color:#fe6a00;
border-radius: 4px;
border: #fe6a00;
font-weight: 600;
font-size: 14px;
text-align: center;
padding-top: 5px;
color: #FFFFFF;
&:hover {
  background-color:#fe6a00;
  color: #FFFFFF;
}
`;

export const ModulesContainer = styled.div`
width: 100%; 
min-height: 100px; 
position: relative;
top: 80px; 
padding: 30px 50px 100px 50px; 
`;

export const StyledFontIcon = styled(FontAwesomeIcon)`
padding-top: 5px;
margin:0 12px;
color: #A2A2A9;
fontSize: 2px;
&:hover {
    color: #fe6a00;
    cursor: pointer ;
} 
`;

export const ModuleToggle = styled.div`
display: flex; 
border-bottom: 1px solid #d1cfcf; 
justify-content: space-between;
`;

export const ModuleName = styled.div`
padding: 25px 5px 0 5px;
height: 60px;
font-weight: 550;
font-size 16px;
`;

export const VideoName = styled.div`
padding-top: 25px;
padding-left: 5px; 
height: 60px;
font-size 16px;
`;

export const ModuleVideosDiv = styled.div`
width: 100%; 
padding-left: 40px; 
padding-top: 10px;
`;

export const ImgContainer = styled.div`
width: 100%; 
height: 150px; 
text-align: center;
`;

export const CloseIcon = styled(CloseCircleOutlined)`
position: absolute; 
right: 9px; 
top: 9px; 
color: #FFFFFF; 
`;

export const VideoFrame = styled.div`
width: 700px; 
height: 350px; 
position: fixed; 
z-index: 10;
top: 200px; 
transform: translateX(250px);
left: 160px; 
background-color: #141313;
padding: 15px 40px 15px 25px; 
border-radius: 15px;
text-align: center;                    
`;

export const SearchDiv = styled.div`
text-align: center; 
width: 100%;
`;

export const CollapseArrow = styled.div`
position: relative; 
top:  23px; 
right: 7px; 
`; 

export const ModuleImg = styled.img`
width: 100%;
height: 100%;
`
